<!--
 * @Author: wb_guochuang wb_guochuang@kuaishou.com
 * @Date: 2022-07-12 01:30:49
 * @LastEditors: wb_guochuang wb_guochuang@kuaishou.com
 * @LastEditTime: 2022-07-12 02:39:20
 * @FilePath: \ancient-book\src\components\versionModal.vue
 * @Description: 版本调阅弹窗
-->
<template>
  <a-modal
    title="版本阅读"
    :visible="visible"
    @cancel="closeModal"
    :footer="null"
  >
    <div class="version-content">
      <div class="version-content-search">
        <a-input-search placeholder="请输入名称" v-model="name" @search="handleSearch"/>
        <div class="version-content-search-sort" @click="handleSort">
          <span>时间倒序</span>
          <a-icon v-if="sortFlag" type="down" />
          <a-icon v-else type="up" />
        </div>
      </div>
      <div class="version-content-list">
        <div class="version-content-list-item" v-for="(item, index) in copyData" :key="item.id">
          <div class="version-content-list-item-info">
            <div class="version-content-list-item-info-img">
              <img v-if="item.metaCover" :src="item.metaCover" alt="" />
            </div>
            <div class="version-content-list-item-info-desc">
              <div class="book-name">{{item.metaTitle}}</div>
              <div class="introduce">
                <div class="line">
                  <div>
                    分类： <span>{{item.classify}}</span>
                  </div>
                  <div>
                    古农书版本编号： <span>{{item.metaId}}</span>
                  </div>
                  <div>
                    图片页数：<span>{{item.imgList.length}}</span>
                  </div>
                </div>
                <div class="line">
                  <div>
                    版本： <span>{{item.version}}</span>
                  </div>
                  <div>
                    点校版本信息： <span>{{item.checkInfo}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="version-content-list-item-btn">
            <div>{{item.metaType == 0 ? '底本' : item.metaType == 1 ? '校本' : item.metaType == 2 ? '普通版本' : ''}}</div>
            <div @click="changeVersionOk(index)">调阅</div>
          </div>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>

export default {
  props: ['visible', 'closeModal', 'data', 'type', 'changeVersion'],
  data() {
    return {
      name: '',
      copyData: '',
      sortFlag: false
    }
  },
  created() {
    this.copyData = this.data
  },
  methods: {
    changeVersionOk(index) {
      this.$emit('changeVersion', {
        type: this.type,
        index: index
      })
    },
    handleSearch() {
      this.copyData = []
      this.data.map(item => {
        if (item.metaTitle.indexOf(this.name) != -1) {
          this.copyData.push(item)
        }
      })
    },
    handleSort() {
      this.sortFlag = !this.sortFlag
      if (this.sortFlag) {
        this.copyData.sort((a, b) => {
          return b.createTime > a.createTime ? -1 : 1
        })
      } else {
        this.copyData.sort((a, b) => {
          return b.createTime < a.createTime ? -1 : 1
        })
      }
    }
  }
}

</script>

<style lang="less">
.ant-modal {
  width: 960px !important;
  .ant-modal-body {
    padding: 20px 40px;
    .version-content {
      width: 100%;
      height: 600px;
      display: flex;
      flex-direction: column;
      overflow-y: auto;


      &-search {
        width: 100%;
        height: 45px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .ant-input-affix-wrapper {
          width: 320px;
          height: 32px;
          border: none;
          
          input {
            background: #FFFFFF;
            border-radius: 16px;
            border: 1px solid #ECE0CE;
          }
        }

        &-sort {
          width: 80px;
          height: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;

          span {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #000000;
          }
        }


      }

      &-list {
        flex: 1;
        margin-top: 20px;
        width: 100%;

        &-item {
          width: 100%;
          height: 142px;
          background: #FFFFFF;
          border: 1px solid #ECE0CE;
          padding: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;

          &-info {
            flex: 1;
            height: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            &-img {
              width: 77px;
              height: 102px;
              margin-right: 20px;

              img {
                width: 100%;
                height: 100%;
              }
            }

            &-desc {
              flex: 1;
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: space-between;

              .book-name {
                width: 100%;
                height: 22px;
                font-size: 16px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #947243;
                line-height: 22px;
              }

              .introduce {
                width: 100%;
                flex: 1;
                margin-top: 10px;
                display: flex;
                align-items: center;

                .line {
                  min-width: 150px;
                  height: 100%;
                  display: flex;
                  flex-direction: column;
                  margin-right: 20px;

                  div {
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #a0a0a0;
                    margin-bottom: 5px;

                    span {
                      font-size: 14px;
                      font-family: PingFangSC-Regular, PingFang SC;
                      font-weight: 400;
                      color: #000000;
                    }
                  }
                }


              }



            }


          }




          &-btn {
            width: 100px;
            height: 74px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;

            div {
              width: 100%;
              height: 32px;
              border-radius: 4px;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
            }

            div:nth-child(1) {
              background: #E2E2E2;
              color: #000000;
            }

            div:nth-child(2) {
              background: #CBAB7A;
              color: #FFFFFF;
              cursor: pointer;
            }
          }

        }
        
      }
    }
  }
  

}


</style>